import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary';

import LoginScreen from '../screens/Login';
import ForgotPasswordScreen from '../screens/ForgotPassword';
import SetPasswordScreen from '../screens/SetPassword';
import ChangePasswordScreen from '../screens/ChangePassword';
import MFASetupScreen from '../screens/MFASetup';

import DashboardScreen from '../screens/Dashboard';
import TriageBoardScreen from '../screens/TriageBoard';
import NetworkTrafficScreen from '../screens/NetworkTraffic';
import NetworkTrafficLiveScreen from '../screens/NetworkTrafficLive';
import NetworkAlertsScreen from '../screens/NetworkAlerts';
import ApplianceSecurityScreen from '../screens/ApplianceSecurity';
import FileTransfersScreen from '../screens/FileTransfers';
import WeeklyNetTrafficPage from '../screens/WeeklyNetTrafficPage';
import IDSRulesScreen from '../screens/IDSRules';
import ImportIDSScreen from '../screens/IDSRules/ImportIDS';

import DeniedListsScreen from '../screens/DeniedLists';
import IOCListsScreen from '../screens/IOCLists';
import BlockingScreen from '../screens/Blocking';
import WatcherSettingsScreen from '../screens/WatcherSettings';
import WatcherSettingsSummaryScreen from '../screens/WatcherSettingsSummary';

import WatcherAssetsScreen from '../screens/WatcherAssets';
import WatcherDataScreen from '../screens/WatcherData';
import WatcherStatusScreen from '../screens/WatcherStatus';
import WatchersScreen from '../screens/Watchers';
import CompaniesScreen from '../screens/Companies';

import BacNETScreen from '../screens/BacNET';
import DNP3Screen from '../screens/DNP3';
import ModbusScreen from '../screens/Modbus';
import S7CommsScreen from '../screens/S7Comms';
import OTSettingsScreen from '../screens/OTSettings';

import DeviceScreen from '../screens/Device';
import DeviceVendorsScreen from '../screens/DeviceVendors';
import UsersScreen from '../screens/Users';
import AuditLogScreen from '../screens/AuditLog';
import AccountScreen from '../screens/Account';
import SwitchCAM from '../screens/SwitchCAM';
import ImportSwitchCAM from '../screens/SwitchCAM/ImportSwitchCAM';
import NotFound from '../screens/404Page';
import NetZones from '../screens/NetZones';
import ImportNetZones from '../screens/NetZones/ImportNetZones';
import AssetBaselineScreen from '../screens/AssetBaseline';
import AttackSurfaceScreen from '../screens/AttackSurface';
import MorningWatchScreen from '../screens/MorningWatch';
import SocAnalyticsScreen from '../screens/SocAnalytics';
import SecurityReports from '../screens/SecurityReports';
import PcapViewer from '../screens/PcapViewer';
import ATTACKMappingScreen from '../screens/ATTACKMapping';
import AnnualReportScreen from '../screens/AnnualReport';
import SystemUpdates from '../screens/SystemUpdates';

const Navigation = () => {
  const location = useLocation();
  return (
    <ErrorBoundary key={location.pathname} routePath={location.pathname}>
    <Routes>
      <Route path='/' element={<TriageBoardScreen />} />
      <Route path='/dashboard' element={<DashboardScreen />} />
      <Route path='/network-traffic' element={<NetworkTrafficScreen />} />
      <Route path='/network-alerts' element={<NetworkAlertsScreen />} />
      <Route path='/appliance-security' element={<ApplianceSecurityScreen />} />
      <Route path='/file-transfers' element={<FileTransfersScreen />} />
      <Route path='/live-traffic' element={<NetworkTrafficLiveScreen />} />
      <Route path='/weekly-traffic' element={<WeeklyNetTrafficPage />} />
      <Route path='/ids-rules' element={<IDSRulesScreen />} />
      <Route path='/import-ids' element={<ImportIDSScreen />} />

      <Route path='/denied-lists' element={<DeniedListsScreen />} />
      <Route path='/ioc-lists' element={<IOCListsScreen />} />
      <Route path='/blocking' element={<BlockingScreen />} />
      <Route path='/watcher-settings' element={<WatcherSettingsSummaryScreen />} />
      <Route path='/config-settings' element={<WatcherSettingsScreen />} />

      <Route path='/watcher-assets' element={<WatcherAssetsScreen />} />
      <Route path='/watcher-data' element={<WatcherDataScreen />} />
      <Route path='/watcher-status' element={<WatcherStatusScreen />} />
      <Route path='/watchers' element={<WatchersScreen />} />
      <Route path='/companies' element={<CompaniesScreen />} />

      <Route path='/bacnet' element={<BacNETScreen />} />
      <Route path='/dnp3' element={<DNP3Screen />} />
      <Route path='/modbus' element={<ModbusScreen />} />
      <Route path='/s7-comms' element={<S7CommsScreen />} />
      <Route path='/ot-settings' element={<OTSettingsScreen />} />

      <Route path='/device' element={<DeviceScreen />} />
      <Route path='/device-vendors' element={<DeviceVendorsScreen />} />
      <Route path='/users' element={<UsersScreen />} />
      <Route path='/audit-log' element={<AuditLogScreen />} />
      <Route path='/my-account' element={<AccountScreen />} />
      <Route path='/switch-cam' element={<SwitchCAM />} />
      <Route path='/switch-cam/import' element={<ImportSwitchCAM />} />
      <Route path='/login' element={<LoginScreen />} />
      <Route path='/forgot-password' element={<ForgotPasswordScreen />} />
      <Route path='/set-password' element={<SetPasswordScreen />} />
      <Route path='/change-password' element={<ChangePasswordScreen />} />
      <Route path='/mfa-setup' element={<MFASetupScreen />} />
      <Route path='/net-zones' element={<NetZones />} />
      <Route path='/net-zones/import' element={<ImportNetZones />} />
      <Route path='/asset-baseline' element={<AssetBaselineScreen />} />
      <Route path='/security-reports' element={<SecurityReports />} />
      <Route path='/annual-report' element={<AnnualReportScreen />} />
      <Route path='/pcap-viewer' element={<PcapViewer />} />
      <Route path='/attack-mapping' element={<ATTACKMappingScreen />} />
      <Route path='/external-baseline-comms' element={<AttackSurfaceScreen />} />
      <Route path='/morningwatch' element={<MorningWatchScreen />} />
      <Route path='/soc-analytics' element={<SocAnalyticsScreen />} />
      <Route path='/system-updates' element={<SystemUpdates />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
    </ErrorBoundary>
  );
};

export default Navigation;
